import React from 'react';
import { translate } from 'react-jhipster';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import UploadFileIcon from '@mui/icons-material/UploadFile';

interface PendingAmountTransferredCardProps {
  count: number;
  onNavigate: (path: string) => void;
}

export const PendingAmountTransferredCard = ({ count, onNavigate }: PendingAmountTransferredCardProps) => {
  const safeCount = count > 0 ? count : 0;

  return (
    <Card className="action-paper" onClick={() => onNavigate('/pending-amount-transferred')}>
      <CardActionArea>
        <CardContent sx={{ backgroundColor: '#FFEDD4' }}>
          <Grid container spacing={2}>
            <Grid item xs className="left-side-component-flex">
              <Typography variant="h6" sx={{ color: '#F54900' }}>
                <strong>{safeCount}</strong>
              </Typography>
            </Grid>
            <Grid item xs className="right-side-component-flex">
              <UploadFileIcon className="icon-card" sx={{ color: '#F54900' }} />
            </Grid>
          </Grid>
          <Typography variant="body2" sx={{ color: '#F54900' }}>
            {translate('home.topInfo.pendingAmountTransferred.title')}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default PendingAmountTransferredCard;
